import axios from 'axios';

const AUTH_TOKEN = 'token';



const instance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 1000,
});

instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;

export const sendMail = async (data) => {
    try {
        const response = await axios.post(process.env.REACT_APP_API_BASE_URL + '/career', data, {
            withCredentials: false,
            headers: {
                'Content-Type': 'application/json'
            }
        });
        console.log('Response:', response.data);
        return response;
    } catch (error) {
        console.error('Error:', error);
        return error;
    }
};